<template>
  <v-row no-gutters>
    <v-col cols="3" class="text-right mr-3 mt-2"> {{ label }}: </v-col>
    <v-col cols="6">
      <v-row no-gutters align="center">
        <ejs-datepicker
          ref="dateObj"
          :locale="locale"
          :placeholder="endDateWatermark"
          v-model="date"
          :format="dateFormat"
          :allowEdit="false"
          :showClearButton="false"
          :enableMask="true"
          @change="validateDate"
          :min="minEndDate"
          :focus="onFocus"
          :enabled="!hasPastMeetings"
        ></ejs-datepicker>
      </v-row>
      <v-row no-gutters align="center">
        <span
          v-if="isStartDate && this.hasPastMeetings"
          style="line-height: 14px"
          class="v-text-field__details v-messages theme--light v-messages__wrapper pb-1"
          >{{ lblStateDateDisabledNote }}</span
        >
        <span
          v-if="!isValid"
          class="v-text-field__details v-messages__message error--text"
          >{{ errorMessage }}</span
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";

Vue.use(DatePickerPlugin);
export default {
  name: "StartDate",
  props: {
    value: {
      type: [String, Date],
      default: new Date(),
    },
    isRemoveBtnShow: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Start",
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    minEndDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    hasPastMeetings: {
      type: Boolean,
      default: false,
    },
    isStartDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: "",
    };
  },
  computed: {
    startLable() {
      return this.$t("Start");
    },
    lblStateDateDisabledNote() {
      return this.$t("lblStateDateDisabledNote");
    },
    endDateWatermark() {
      return this.$t("lblSelectDate");
    },
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    date: {
      get() {
        return this.value ? new Date(this.value) : null;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    errorMessage() {
      return !this.isValid ? this.$t("lblSelectEndDate") : "";
    },
  },
  methods: {
    onRemoveEndDate,
    validateDate,
    onFocus,
  },
};

function onFocus(args) {
  this.$refs.dateObj.show();
}

function validateDate(Data) {
  this.$emit("change", Boolean(Data.value));
}
function onRemoveEndDate() {
  this.$emit("input", null);
}
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
</style>